import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'vc-get-paid-error',
  templateUrl: './get-paid-error.component.html',
  styleUrls: ['./get-paid-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GetPaidErrorComponent {
  constructor() {}
}
